import React from 'react';
import * as S from './styles';
import Events from '../../Events';
import Aguas from '../../../front-novo/icons/Aguas.svg';
import Tronco from '../../../front-novo/icons/Tronco.svg';
import Cacto from '../../../front-novo/icons/Cacto.svg';
import Gaviao from '../../../front-novo/icons/Gaviao.svg';
import bordercardimg from '../../../front-novo/home/bordercardimg.png';

function Home2() {
  return (
    <S.Main>
      <S.Section>
        <S.TextDiv>
          <img src={Aguas} />
          <p>
            Este programa é destinado a profissionais e estudantes que desejam
            aprofundar seus conhecimentos teóricos e clínicos.
            <br />
            <br />
            Com base no rigor ético e na tradição psicanalítica, o curso integra
            perspectivas clássicas e contemporâneas, desde Freud até autores
            como Klein, Winnicott, Lacan, Bleichmar e outros. O objetivo é
            formar clínicos e pesquisadores críticos, capazes de desenvolver um
            estilo próprio e uma escuta sensível, longe de modelos
            estereotipados.
          </p>
          {/* <a href="https://drive.google.com/drive/folders/1V6HzMm1dAmu2HPSSVUrEMyRXP4oNAKsP">
            <button>Acesse agora</button>
          </a> */}
        </S.TextDiv>
      </S.Section>
    </S.Main>
  );
}

export default Home2;
